import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=c4abca2e&scoped=true&"
import script from "./SaleDetails.vue?vue&type=script&lang=ts&"
export * from "./SaleDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=c4abca2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4abca2e",
  null
  
)

export default component.exports